import $ from 'jquery'
import { loadStripe } from '@stripe/stripe-js'

// eslint-disable-next-line no-undef
const stripeI18n = bookingHubStripe

// eslint-disable-next-line no-undef
const pluginI18n = bookingHub

let elements

window.addEventListener('bookingHubPaymentStep', (event) => {
  const { mainEl, bookingForm, bookingId, submit, paymentMethod } = event.detail

  if (paymentMethod !== stripeI18n.methodName) return

  loadStripe(stripeI18n.publishableKey).then((stripe) => {
    $.ajax({
      url: pluginI18n.ajaxUrl,
      method: 'POST',
      dataType: 'json',
      data: {
        action: 'bhub/payments/stripe/get_form',
        _ajax_nonce: pluginI18n.nonce,
        bookingForm,
        bookingId,
      },
      success: (res) => {
        if (res.success) {
          elements = stripe.elements(res.data)
          const formEl = mainEl.querySelector(
            '.bhub-stripe-payment-form__iframe-handler'
          )

          const paymentElementOptions = {
            layout: 'tabs',
          }

          const paymentElement = elements.create(
            'payment',
            paymentElementOptions
          )
          paymentElement.mount(formEl)
          paymentElement.on('ready', function () {
            mainEl.querySelector('.bhub-price-amount--styled').style.display =
              'block'
            mainEl.querySelector(
              '.bhub-stripe-payment-form__submit'
            ).style.display = ''
            mainEl.querySelector('.bhub-loader').remove()
          })
        } else {
          alert(res.data.message)
        }
      },
    })

    $(mainEl).on('submit', '.bhub-stripe-payment-form', (e) => {
      e.preventDefault()

      stripe
        .confirmPayment({
          elements,
          confirmParams: {},
          redirect: 'if_required',
        })
        .then((res) => {
          if (res?.error?.message) {
            alert(res.error.message)
          } else {
            submit(res)
          }
        })
    })
  })
})
